import { StyleProp, ViewStyle } from 'react-native';
import { ContentViewStyle } from '@levelapp/softfabric';

export default class LogTabViewStyle extends ContentViewStyle {
  filters: StyleProp<ViewStyle> = {
    marginLeft: 35,
    marginTop: 25,
  }
}